/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {camelizeKeys, decamelizeKeys} from 'humps'
import {useSelector} from 'react-redux'

import {
  king_reward_type,
  throne_info,
  throne_status,
  winner_type,
} from './Throne/interface'
// [猜宝箱活动首页] https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=2319489
const getBoxMainApi = async (store) => {
  const resp = await http.outPost<
    HiyaRes<
      Pick<
        InitialStateType,
        | 'diamondBalance'
        | 'guessBoxCfgs'
        | 'choices'
        | 'guessBoxKeyCfgs'
        | 'guessBoxState'
        | 'guessBoxWinBalance'
        | 'recentWinBox'
        | 'crownFightInfo'
        | 'repeated'
        | 'hotBoxs'
      >
    >
  >('/live/activity/guess_box', store.getState().env.deviceinfo)
  return camelizeKeys(resp.data.data) as typeof resp.data.data
}
// 获取首页信息
export const getGuessBoxMainInfo = createAsyncThunk(
  'getGuessBoxMainInfo',
  async (arg, store) => getBoxMainApi(store)
)
// 更新账户余额
export const updateBalanceByApi = createAsyncThunk(
  'updateBalanceByApi',
  async (arg, store) => getBoxMainApi(store)
)

// 【猜宝箱榜单】 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=2319411
export const getGuessBoxTopList = createAsyncThunk(
  '/live/activity/guess_box_top_list',
  async (arg, store) => {
    const resp = await http.outPost<HiyaRes<InitialStateType['topListData']>>(
      '/live/activity/guess_box_top_list',
      store.getState().env.deviceinfo,
      {
        xcHideLog: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)

// [当前活动状态+下注详情+betId(下注的唯一ID递增[毫秒级时间戳])] https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=2319406
const guessBoxActStateApi = async (store) => {
  const resp = await http.outPost<
    HiyaRes<
      InitialStateType['guessBoxState'] & {
        choices: InitialStateType['choices']
      } & {
        // 皇冠信息是可能不存在的 下划线改成驼峰模式
        crownFightInfo?: InitialStateType['crownFightInfo']
        repeated?: InitialStateType['repeated']
      }
    >
  >('/live/activity/guess_box_acti_state', store.getState().env.deviceinfo, {
    xcHideLog: true,
  })
  return camelizeKeys(resp.data.data) as typeof resp.data.data
}
// 当前活动状态
export const getGuessBoxActState = createAsyncThunk(
  'getGuessBoxActState',
  async (arg, store) => guessBoxActStateApi(store)
)
// 下注详情
export const updateChoices = createAsyncThunk(
  'updateChoices',
  async (arg, store) => guessBoxActStateApi(store)
)

const MAX_BET_QUEUE_LENGTH = 5
let betRequestQueue = [] // 下注请求队列，限制长度为5
let loadingTimer = null
// [猜宝箱下注] https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=2319409
export const getGuessBoxBet = createAsyncThunk(
  'getGuessBoxBet',
  async ({params, updateParams}: any, store) => {
    if (
      betRequestQueue.length >= MAX_BET_QUEUE_LENGTH ||
      (betRequestQueue[0] &&
        updateParams.betId - betRequestQueue[0].betId > 1000)
    ) {
      store.dispatch(GameGuessboxSlice.actions.changeBetLoading(true))
      loadingTimer = setTimeout(() => {
        store.dispatch(GameGuessboxSlice.actions.changeBetLoading(false))
      }, 3000)
      return Promise.reject(new Error('超过限制长度'))
    }
    betRequestQueue = [...betRequestQueue, updateParams]
    const resp = await http.post<HiyaRes<any>>('/live/activity/guess_box_bet', {
      ...store.getState().env.deviceinfo,
      ...params,
    })
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)

export const getGuessBoxDraw = createAsyncThunk(
  'getGuessBoxDraw',
  async (actId: number, store) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/activity/guess_box_draw',
      {
        ...store.getState().env.deviceinfo,
        act_id: actId,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)

export const getGuessBoxhistory = createAsyncThunk(
  '/live/activity/guess_box_draw_history',
  async (actId: number, store) => {
    const resp = await http.outPost<HiyaRes<any>>(
      '/live/activity/guess_box_draw_history',
      {
        ...store.getState().env.deviceinfo,
        act_id: actId,
      },
      {
        xcHideLog: true,
      }
    )
    return camelizeKeys(resp.data.data) as typeof resp.data.data
  }
)

interface InitialStateType {
  // ---数据----
  // 账号余额
  diamondBalance?: number
  // 当日所赢
  guessBoxWinBalance?: number
  // 八个宝箱配置
  guessBoxCfgs?: Array<{
    boxId: number
    boxPrize: number
    isNew: boolean
    boxIconUrl: string
    hotTopn?: number
  }>
  // 8个宝箱的相关的火焰设置
  // hot_topn: 1:大火；2:中火；3:小火
  hotBoxs?: {
    boxId: number
    hotTopn: number
  }[]
  // 四个钥匙配置
  guessBoxKeyCfgs?: any
  // 当前轮次状态对象
  guessBoxState?: {
    // 当前轮次ID
    actId: number
    // 当前轮次
    actDateTurn: number
    // 当前轮次状态
    actState: number
    // 顶部左右小图标(神兽大奖状态)动画
    animalState: number
    // 倒计时
    leftDuration: number

    boxIds: string[]
  }
  // 最近中奖宝箱
  recentWinBox?: Array<{
    actId: number
    boxId: number
    boxPrize: number
    isNew: boolean
    boxIconUrl: string
  }>
  // 本场下注
  choices?: {
    [key in string]: {
      // 下注数量
      betAmount: number
      // 选中第几个 = key
      choice: number
      // 支付金额
      payAmount: number
    }
  }
  // 排名
  topListData?: any
  // ---界面---
  betLoading: boolean
  drawInfo?: any
  // 以下信息为王座争夺战附加信息
  // 当前轮的王座信息
  crownFightInfo?: throne_info
  // 上一轮的王座信息 用于触发屏幕内王座更新的弹幕
  preCrownFightInfo?: throne_info
  // 王座上的获奖人的信息
  kingReward?: king_reward_type
  // 	本区的本轮top1赢取金额玩家信息
  areaWinner?: king_reward_type
  // 是否可以重复上一轮下注情景
  repeated?: boolean
  // loadingPage 加载页
  loadingPage: boolean
}

const initialState: any = {}
const initData = {
  betLoading: false,
  loadingPage: true,
  drawInfo: {},
  // TODO 用于测试王座得奖弹幕 获得王座上奖的人 一次性跑完直接干掉
  // kingReward: {
  //   id: 10740,
  //   mid: 10740,
  //   coins: 1000,
  //   zyId: '10740',
  //   avatar: 'http://image.meihiya.com/avatar.png',
  //   name: 'lucy',
  // },
}

const getChoices = (befChoices = {}, uptChoices = {}) => {
  const choices = uptChoices
  for (const kid in uptChoices) {
    if (befChoices[kid]) {
      choices[kid].betAmount = Math.max(
        befChoices[kid].betAmount,
        uptChoices[kid].betAmount
      )
      choices[kid].payAmount = Math.max(
        befChoices[kid].payAmount,
        uptChoices[kid].payAmount
      )
    }
  }
  return choices
}

export const GameGuessboxSlice = createSlice({
  name: 'Animal_Owl',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    // 更新王座得钱的人的信息
    set_throne_king: (state, action: PayloadAction<king_reward_type>) => {
      Object.assign(state, {
        kingReward: action.payload,
      })
    },
    // 获得王座上的钱的人
    reset_throne_king: (state, action) => {
      Object.assign(state, {
        kingReward: null,
      })
    },
    updateHotBox: (
      state,
      action: PayloadAction<
        {
          box_id: number
          hot_topn: number
        }[]
      >
    ) => {
      if (!action.payload?.length) {
        return
      }
      const {guessBoxCfgs} = state
      guessBoxCfgs?.forEach((b, bIdx) => {
        const item = action.payload?.find((hb) => hb.box_id === b.boxId)
        if (item) {
          guessBoxCfgs[bIdx].hotTopn = item.hot_topn || 0
        } else {
          // 如果更新的数组里面没有当前的下注物 就直接将当前的下注物置为不热门即可
          guessBoxCfgs[bIdx].hotTopn = 0
        }
      })
      Object.assign(state, {
        guessBoxCfgs,
      })
    },
    changeBetLoading: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        betLoading: action.payload,
      })
    },
    changeLoadingPage: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, {
        loadingPage: action.payload,
      })
    },
    initChoices: (state) => {
      Object.assign(state, {
        choices: {},
      })
    },
    updateSelfBalance: (state, action: PayloadAction<number>) => {
      const {diamondBalance, guessBoxWinBalance} = state
      const getAmount = action.payload || 0
      Object.assign(state, {
        diamondBalance: diamondBalance + getAmount,
        guessBoxWinBalance: guessBoxWinBalance + getAmount,
      })
    },
  },
  extraReducers: (builder) => {
    // 首页信息
    builder.addCase(getGuessBoxMainInfo.fulfilled, (state, action) => {
      const {crownFightInfo, hotBoxs, ...rest} = action.payload
      if (hotBoxs?.length) {
        // 如果有热门下注盒子的信息
        rest.guessBoxCfgs?.forEach((b, bIdx) => {
          const item = hotBoxs?.find((hb) => hb.boxId === b.boxId)
          if (item) {
            rest.guessBoxCfgs[bIdx].hotTopn = item.hotTopn || 0
          } else {
            rest.guessBoxCfgs[bIdx].hotTopn = 0
          }
        })
      }
      // 从当前redux中取出当前的王座信息
      const {crownFightInfo: cur_crown_fight_info} = state
      // 如果当前王座信息没有并且接口回传的数据有 就说明是页面刚刚被打开 服务端渲染阶段
      if (!cur_crown_fight_info && crownFightInfo) {
        Object.assign(state, {
          ...rest,
          crownFightInfo: {
            ...crownFightInfo,
            actId: action.payload.guessBoxState.actId,
          },
        })
        return
      }
      // 否则就直接保存除了王座争夺的别的信息即可
      Object.assign(state, rest)
    })
    // 更新余额
    builder.addCase(updateBalanceByApi.fulfilled, (state, action) => {
      Object.assign(state, {
        diamondBalance: action.payload.diamondBalance,
        guessBoxWinBalance: action.payload.guessBoxWinBalance,
      })
    })
    // 排行榜
    builder.addCase(getGuessBoxTopList.fulfilled, (state, action) => {
      Object.assign(state, {
        topListData: action.payload,
      })
    })
    // 轮次状态
    builder.addCase(getGuessBoxActState.fulfilled, (state, action) => {
      const {choices, ...guessBoxState} = action.payload
      Object.assign(state, {
        guessBoxState,
      })
    })
    // 更新选中
    builder.addCase(updateChoices.fulfilled, (state, action) => {
      const {choices, actId, crownFightInfo, repeated} = action.payload
      // 从当前redux中取出当前的王座信息
      const {crownFightInfo: cur_crown_fight_info} = state
      clearTimeout(loadingTimer)
      betRequestQueue = []
      // 在act_state === 1投注的时候这个action updateChoices会被调用 所以不用关注在act_state不是投注状态的时候的状况
      // 以下几种情况不需要更新王座相关的信息 走老的逻辑即可
      // 1. 当前王座信息和过去的王座信息都不存在的情况 说明当前并没有开启王座争夺
      if (!cur_crown_fight_info && !crownFightInfo) {
        return {
          ...state,
          choices: getChoices(state.choices, choices),
          betLoading: false,
          repeated,
        }
      }

      // 如果接口返回的轮次信息当前state里面的轮次信息不一致就需要把当前的王座信息更新成上一轮的王座信息，把当前轮次的信息储存起来
      if (
        actId !== cur_crown_fight_info?.actId &&
        cur_crown_fight_info?.actId
      ) {
        return {
          ...state,
          choices: getChoices(state.choices, choices),
          betLoading: false,
          crownFightInfo: {...crownFightInfo, actId},
          preCrownFightInfo: cur_crown_fight_info,
          repeated,
        }
      }
      // 如果当前轮次的王座信息刷新了就更新当前王座信息的数值即可，注意不要把之前的王座信息的轮次id刷掉了
      return {
        ...state,
        choices: getChoices(state.choices, choices),
        betLoading: false,
        crownFightInfo: {...cur_crown_fight_info, ...crownFightInfo, actId},
        repeated,
      }
    })
    // 下注
    builder.addCase(getGuessBoxBet.fulfilled, (state, action) => {
      const {diamondBalance, choices, betId, status} = action.payload
      clearTimeout(loadingTimer)
      const betIndex = betRequestQueue.findIndex((bet) => bet.betId === betId)
      betRequestQueue = betRequestQueue.slice(betIndex + 1)
      if (status !== 1) {
        // 如果下注没有成功就不需要对目前的数据做处理了
        // 0:失败;1:成功;2:余额不足
        return
      }
      Object.assign(state, {
        diamondBalance,
        choices: getChoices(state.choices, choices),
        betLoading: false,
      })
    })
    builder.addCase(getGuessBoxDraw.fulfilled, (state, action) => {
      const {guessBoxState, choices, ...drawInfo} = action.payload
      Object.assign(state, {
        guessBoxState,
        choices,
        drawInfo,
        betLoading: false,
      })
    })
  },
})
export default GameGuessboxSlice.reducer
export const useGameGuessboxState = () => {
  const data = useSelector((state) => state.Animal_Owl)
  return data
}
export const GameGuessboxActions = GameGuessboxSlice.actions
